import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { App } from './App'
import { ToastProvider } from './components/Toast'
// Self-hosted fonts (offline-safe, no external CDN) — Inter for UI, JetBrains Mono for
// technical/monospace values. LATIN subset only: the full package ships cyrillic/greek/
// vietnamese/latin-ext too (~20 files) which slowed first paint for no benefit here.
import '@fontsource/inter/latin-400.css'
import '@fontsource/inter/latin-500.css'
import '@fontsource/inter/latin-600.css'
import '@fontsource/inter/latin-700.css'
import '@fontsource-variable/jetbrains-mono/wght.css'
import './index.css'
import './data.css'

// Apply the saved theme before first paint so a hard refresh never flashes the wrong palette.
{
  const t = localStorage.getItem('bms-theme')
  if (t === 'light' || t === 'dark') document.documentElement.setAttribute('data-theme', t)
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // A 401 or a 403 will not fix itself by retrying, and retrying a rejected
      // send would be actively harmful.
      retry: (count, err: any) => count < 2 && ![401, 403, 404, 409].includes(err?.status),
      staleTime: 15_000,
      refetchOnWindowFocus: false,
    },
  },
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <ToastProvider>
          <App />
        </ToastProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
)
